import { SportType } from "../models/court/dto/court.dto";

export const letters = ['D-', 'D', 'D+', 'C-', 'C', 'C+', 'B-', 'B', 'B+', 'A-', 'A', 'A+', 'S'];

/**
 * Padel "Équivalence Classement → Point Mooving Arena" (MYS-39).
 * Our internal level (1–10) sits on the same numeric scale as the Padel
 * federation classement (1–10.5) in that table, so it maps straight onto the
 * Mooving Arena point (0–20): point = 2·level − 1, anything below 1 = Nc (0).
 * NOTE: kept frontend-side for now; canonical home is the API SportLevel DTO.
 */
export function getPadelMoovingPoint(level?: number): number | undefined {
    if (level == null || Number.isNaN(level)) return undefined;
    if (level < 1) return 0;
    return Math.min(20, Math.max(1, Math.round(level * 2 - 1)));
}

/** Mooving Arena point for a sport+level. Only Padel is mapped today (MYS-39). */
export function getMoovingPoint(sportType: SportType, level?: number): number | undefined {
    if (sportType !== SportType.PADEL && sportType !== SportType.PADEL1V1) return undefined;
    return getPadelMoovingPoint(level);
}

/** Orgs where the Mooving Arena point is surfaced (MYS-39): Mooving + MySportSet-dev. */
const MOOVING_ARENA_ORG_IDS = new Set([
    '335a28aa-3271-4bbd-afde-664dc5cc5252', // Mooving (Mooving-staging)
    'ba31ccde-072e-4770-83f3-01ed7028316d', // MySportSet-dev
]);

export function isMoovingArenaEnabledForOrg(organizationId?: string): boolean {
    return !!organizationId && MOOVING_ARENA_ORG_IDS.has(organizationId);
}

export function levelToLetter(level?: number) {
    if (level === undefined) return '';
    const index = Math.min(Math.floor(level / 15), letters.length - 1);
    return letters[index];
}
export function letterToLevel(letter: string) {
    const index = letters.indexOf(letter);
    return Math.floor(index * 15);
}